import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getStaffDesignation,
  setStaffEditData,
} from "../../../../../store/slices/Staffs/staffsSlice";
import InfiniteDotLoader from "../../../../../utils/InfiniteDotLoader";
import CommonInput from "../../../../Layouts/CommonInput";
import Icon from "../../../../Layouts/Icons";
import CommonModal from "../../../../Modals/CommonModal";
import Style from "./AddStaff.module.scss";

const AddStaff = ({
  showAddStaffModal,
  setShowAddStaffModal,
  staffValidationSchema,
  staffSubmit,
  preSelectstaffType,
  designations,
  showEventModal,
  handleStaffModal,
  setCustomDesignation,
  customDesignation,
}) => {
  const dispatch = useDispatch();
  const [defaultValue, setDefaultValue] = useState("");
  const [showError, setShowError] = useState(false);

  const { addStaffData, addStaffStatus, addStaffError, status } = useSelector(
    (state) => state.preferenceList
  );

  // const { sections } = useSelector((state) => state.project);
  const {
    editStaff,
    staffPreSelect,
    designationsStatus,
    destinations,
    staffSkipStatus,
    sections,
  } = useSelector((state) => state.staffs);

  const [staffType, setStaffType] = useState(
    preSelectstaffType != undefined ? preSelectstaffType : null
  );

  useEffect(() => {
    if (Object.keys(editStaff?.staffData).length > 0) {
      setStaffType(editStaff?.staffData?.staff_type);
    }

    if (editStaff?.status === false) {
      setStaffType("");
    }
  }, [editStaff?.staffData]);

  useEffect(() => {
    setStaffType(staffPreSelect);
  }, [staffPreSelect]);

  useEffect(() => {
    if (showAddStaffModal || designationsStatus == "idle") {
      dispatch(getStaffDesignation());
    }
    if (
      editStaff?.staffData?.designation_id === null &&
      editStaff?.staffData?.designation_name
    ) {
      setCustomDesignation(true);
    } else if (
      Number.isInteger(
        editStaff?.staffData?.designation_id &&
          !editStaff?.staffData?.designation_name
      )
    ) {
      setCustomDesignation(false);
    }
    if (
      Number.isInteger(editStaff?.staffData.designation_id) &&
      editStaff?.staffData?.designation_name !== undefined &&
      !editStaff?.staffData?.designation_name
    ) {
      setDefaultValue(
        designations?.find(
          (item) => item?.value === editStaff?.staffData.designation_id
        )?.label
      );
    } else if (
      Number.isInteger(editStaff?.staffData.designation_id) &&
      editStaff?.staffData?.designation_name
    ) {
      setCustomDesignation(true);
    }

    return () => {
      if (editStaff?.status) {
        setDefaultValue("");
        setCustomDesignation(false);
      }
    };
  }, [showAddStaffModal]);

  const handleCancelModal = (data) => {
    setCustomDesignation(false);
    const { resetForm } = data;
    setDefaultValue("");
    setStaffType("");
    resetForm();
    if (showEventModal) {
      showEventModal(true);
    }
    setShowAddStaffModal(false);
  };
  const handleCloseModal = () => {
    setShowAddStaffModal(false);
    setCustomDesignation(false);
  };

  const getCurrentDestination = (id) => {
    let index = designations?.findIndex((obj) => obj.value == id);
    if (index > -1) {
      return designations[index];
    }
    return null;
  };
  return (
    <Formik
      validationSchema={staffValidationSchema}
      initialValues={{
        staff_name: editStaff?.status !== true ? "" : editStaff?.staffData.name,
        staff_mobile:
          editStaff?.status !== true ? "" : editStaff?.staffData.mobile,
        staff_email:
          editStaff?.status !== true ? "" : editStaff?.staffData.email,
        staff_designation: Number.isInteger(editStaff?.staffData.designation_id)
          ? editStaff?.staffData.designation_id
          : editStaff?.status === true
          ? "custom"
          : "",
        custom_designation: editStaff?.staffData.designation_name
          ? editStaff?.staffData.designation_name
          : "",
        country_dial_code:
          editStaff?.status !== true
            ? "+91"
            : editStaff?.staffData.country_dial_code,
        staff_type:
          editStaff?.status !== true
            ? staffPreSelect != ""
              ? staffPreSelect
              : ""
            : editStaff?.staffData.staff_type,
      }}
      enableReinitialize={true}
      onSubmit={async (values, { resetForm, setFieldError }) => {
        let FormData = {
          name: values?.staff_name,
          email: values?.staff_email,
          mobile: values?.staff_mobile,
          country_dial_code: values?.country_dial_code,
          staff_type: values?.staff_type,
          designation_id: values?.staff_designation,
          designation_name: "",
        };
        if (editStaff?.status == true) {
          FormData.id = editStaff?.staffData.id;
          if (editStaff?.staffData.staff_type != values?.staff_type) {
            FormData.type_changed = true;
          }
        }
        if (
          values?.custom_designation != "" &&
          values?.custom_designation != undefined
        ) {
          // FormData.designation_id = null;
          delete FormData.designation_id;
          FormData.designation_name = values?.custom_designation;
        } else if (
          Number.isInteger(values?.staff_designation) &&
          !values?.custom_designation
        ) {
          FormData.designation_id = values.staff_designation;
          FormData.designation_name = "";
        }
        staffSubmit(FormData, resetForm, setFieldError, setStaffType, {
          whileEventCreation: true,
        });

        if (editStaff?.status) {
          dispatch(setStaffEditData(FormData));
        }
        setCustomDesignation(false);
        setDefaultValue("");

        if (
          (status !== "loading" && sections?.activeTab?.data?.length > 0) ||
          sections?.contractStaffTab?.data?.length > 0
        ) {
          // handleStaffModal();
          // showEventModal(true);
        } else if (addStaffStatus === false) {
          setShowError(true);
          setTimeout(() => {
            setShowError(false);
            resetForm();
          }, 2000);
        }
      }}
    >
      {({
        errors,
        values,
        touched,
        handleSubmit,
        setFieldValue,
        handleBlur,
        resetForm,
        isValid,
        dirty,
      }) => {
        let selectItem = Object.keys(touched);
        let DesignationErr = errors?.staff_designation
          ? errors?.staff_designation
          : selectItem?.some((item) => item?.includes("react-select"));

        return (
          <>
            <CommonModal
              backdrop="static"
              keyboard={false}
              showModal={showAddStaffModal}
              setShowModal={handleCloseModal}
              centered={true}
              className={`type-lg add-staff-modal`}
              title={<h4>{editStaff?.status ? "Edit" : "Add"} staff</h4>}
              clearState={resetForm}
              content={
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <CommonInput
                        label="Name"
                        type="text"
                        variant="input"
                        name="staff_name"
                        id="input_name"
                        floatingLabel={true}
                        value={values?.staff_name}
                        hasError={errors?.staff_name && touched.staff_name}
                        errorMsg={errors?.staff_name}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("staff_name", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <CommonInput
                        label="Mobile"
                        variant="phone-with-country"
                        floatingLabel={true}
                        id="input_phone"
                        name="staff_mobile"
                        default_country="IN"
                        value={values?.staff_mobile}
                        hasError={errors?.staff_mobile && touched.staff_mobile}
                        errorMsg={errors?.staff_mobile}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("staff_mobile", e.target.value);
                        }}
                        country_dial_code={
                          editStaff?.staffData.country_dial_code
                        }
                        callback={function (country) {
                          setFieldValue("country_dial_code", country.dial_code);
                        }}
                      />
                      {showError ? (
                        <span className={Style.ErrorMessage}>
                          {addStaffError?.staff}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-md-6">
                      <CommonInput
                        label="Email"
                        type="email"
                        variant="input"
                        id="staff_email"
                        floatingLabel={true}
                        name="staff_email"
                        value={values?.staff_email}
                        hasError={errors?.staff_email && touched.staff_email}
                        errorMsg={errors?.staff_email}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("staff_email", e.target.value);
                        }}
                      />
                      {showError ? (
                        <span className={Style.ErrorMessage}>
                          {addStaffError?.email}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className={`${Style.custom_designation_wrap} col-md`}>
                      {!customDesignation && (
                        <>
                          <CommonInput
                            selectedValue={
                              Number.isInteger(designations?.value)
                                ? {
                                    value: designations?.value,
                                    label: designations?.label,
                                  }
                                : false
                            }
                            label={
                              !editStaff?.staffData.designation_id
                                ? "Designation"
                                : ""
                            }
                            id="staff_designation"
                            name="staff_designation"
                            variant="select-input"
                            defaultValue={defaultValue}
                            floatingLabel={true}
                            options={designations?.filter(
                              (item) => item.value !== values?.staff_designation
                            )}
                            value={
                              values?.staff_designation
                                ? values?.staff_designation
                                : ""
                            }
                            onBlur={(e) => {
                              handleBlur(e);
                            }}
                            callback={(value) => {
                              setFieldValue("staff_designation", value);

                              if (value === "custom") {
                                setCustomDesignation(true);
                              } else {
                                setCustomDesignation(false);
                              }
                            }}
                            hasError={
                              errors?.staff_designation &&
                              touched?.staff_designation
                            }
                            errorMsg={errors?.staff_designation}
                          />
                          {defaultValue && (
                            <button
                              className={`${Style.custom_event_close_btn_alter}`}
                              onClick={() => {
                                setDefaultValue("");
                              }}
                            >
                              <Icon color={""} size={14} icon={"icon-close"} />
                            </button>
                          )}
                        </>
                      )}
                    </div>

                    <div className={`${Style.custom_designation_wrap}`}>
                      <CommonInput
                        selectedValue={values.staff_designation}
                        className={customDesignation === true ? "" : "d-none"}
                        label="Designation"
                        id="staff_designation"
                        name="staff_designation"
                        variant="input"
                        floatingLabel={true}
                        options={designations}
                        onBlur={(e) => {
                          handleBlur(e);
                        }}
                        value={
                          values?.custom_designation
                            ? values?.custom_designation
                            : ""
                        }
                        onChange={(e) => {
                          setFieldValue("custom_designation", e.target.value);
                        }}
                        hasError={
                          errors?.staff_designation &&
                          touched?.staff_designation
                        }
                        errorMsg={errors?.staff_designation}
                      />

                      <button
                        className={`${Style.custom_event_close_btn} ${
                          customDesignation === true ? "" : "d-none"
                        }`}
                        onClick={() => {
                          setFieldValue("staff_designation", "");
                          setFieldValue("custom_designation", "");
                          setCustomDesignation(false);
                        }}
                      >
                        <Icon color={""} size={14} icon={"icon-close"} />
                      </button>
                    </div>

                    <div className={`col-md-12 ${Style.checkbox_container}`}>
                      <div className={Style.checkbox_wrap}>
                        <span
                          className={`form-check-box ${
                            staffType === 2 || values?.staff_type === 2
                              ? "checked"
                              : ""
                          }`}
                          onClick={() => {
                            setStaffType(2);
                            setFieldValue("staff_type", 2);
                          }}
                        ></span>
                        <label
                          onClick={() => {
                            setStaffType(2);
                            setFieldValue("staff_type", 2);
                          }}
                        >
                          Permanent staff
                        </label>
                      </div>

                      <div className={Style.checkbox_wrap}>
                        <span
                          className={`form-check-box ${
                            staffType === 1 || values?.staff_type === 1
                              ? "checked"
                              : ""
                          }`}
                          onClick={() => {
                            setStaffType(1);
                            setFieldValue("staff_type", 1);
                          }}
                        ></span>
                        <label
                          onClick={() => {
                            setStaffType(1);
                            setFieldValue("staff_type", 1);
                          }}
                        >
                          Contract staff
                        </label>
                      </div>

                      {/* {errors?.staff_type &&
                        Object.keys(errors).length === 1 && (
                          <span htmlFor="" className="error-message">
                            {errors?.staff_type}
                          </span>
                        )} */}
                    </div>
                  </div>
                </>
              }
              footer={
                <>
                  <button
                    className="btn btn-border-grey"
                    onClick={() => {
                      handleCancelModal({ resetForm: resetForm });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    disabled={!isValid || !dirty || status === "loading"}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {status === "loading" ? <InfiniteDotLoader /> : "Save"}
                  </button>
                </>
              }
            />
          </>
        );
      }}
    </Formik>
  );
};

export default AddStaff;
